"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGateway = void 0;
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
var axios_1 = __importDefault(require("axios"));
var __1 = require("..");
var DataGateway = /** @class */ (function () {
    function DataGateway() {
    }
    DataGateway.setBaseUrl = function (baseUrl) {
        DataGateway.baseUrl = baseUrl.endsWith('/')
            ? baseUrl.substr(0, baseUrl.length - 1)
            : baseUrl;
    };
    DataGateway.setToken = function (accessToken) {
        DataGateway.accessToken = accessToken;
    };
    /**
     * get retrieves payload from the server. Whole response is returned.
     * @param path URL path with leading slash (/)
     * @param params query parameter as plain object
     */
    DataGateway.get = function (_a) {
        var path = _a.path, params = _a.params;
        return __awaiter(this, void 0, void 0, function () {
            var headers, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!DataGateway.baseUrl) {
                            throw new __1.GatewayError("A retrieval request (GET) with a path " + path + " was received. The request failed because no base URL was available");
                        }
                        headers = {
                            'content-type': 'application/json',
                            accept: 'application/json',
                        };
                        if (this.accessToken) {
                            headers = __assign(__assign({}, headers), { authorization: "Bearer " + this.accessToken });
                        }
                        return [4 /*yield*/, axios_1.default({
                                method: 'GET',
                                url: "" + this.baseUrl + (path.startsWith('/') ? path : '/' + path),
                                headers: headers,
                                params: params,
                                validateStatus: function () {
                                    return true;
                                },
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * get deletes payload from the server. Whole response is returned.
     * @param path URL path with leading slash (/)
     * @param params query parameter as plain object
     */
    DataGateway.delete = function (_a) {
        var path = _a.path, params = _a.params;
        return __awaiter(this, void 0, void 0, function () {
            var headers, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!DataGateway.baseUrl) {
                            throw new __1.GatewayError("A delete request (DELETE) with a path " + path + " was received. The request failed because no base URL was available");
                        }
                        headers = {
                            'content-type': 'application/json',
                            accept: 'application/json',
                        };
                        if (this.accessToken) {
                            headers = __assign(__assign({}, headers), { authorization: "Bearer " + this.accessToken });
                        }
                        return [4 /*yield*/, axios_1.default({
                                method: 'DELETE',
                                url: "" + this.baseUrl + (path.startsWith('/') ? path : '/' + path),
                                headers: headers,
                                params: params,
                                validateStatus: function () {
                                    return true;
                                },
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * post stores payload from the server. Whole response is returned.
     * @param path URL path with leading slash (/)
     * @param data represents a JSON string
     * @param params query parameter as plain object
     */
    DataGateway.post = function (_a) {
        var path = _a.path, data = _a.data, params = _a.params;
        return __awaiter(this, void 0, void 0, function () {
            var headers, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!DataGateway.baseUrl) {
                            throw new __1.GatewayError("A create request (POST) with a path " + path + " was received. The request failed because no base URL was available");
                        }
                        headers = {
                            'content-type': 'application/json',
                            accept: 'application/json',
                        };
                        if (this.accessToken) {
                            headers = __assign(__assign({}, headers), { authorization: "Bearer " + this.accessToken });
                        }
                        return [4 /*yield*/, axios_1.default({
                                method: 'POST',
                                url: "" + this.baseUrl + (path.startsWith('/') ? path : '/' + path),
                                headers: headers,
                                params: params,
                                data: data,
                                validateStatus: function () {
                                    return true;
                                },
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * put updates payload on the server. Whole response is returned.
     * @param path URL path with leading slash (/)
     * @param data represents a JSON string
     * @param params query parameter as plain object
     */
    DataGateway.put = function (_a) {
        var path = _a.path, data = _a.data, params = _a.params;
        return __awaiter(this, void 0, void 0, function () {
            var headers, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!DataGateway.baseUrl) {
                            throw new __1.GatewayError("An update request (PUT) with a path " + path + " was received. The request failed because no base URL was available");
                        }
                        headers = {
                            accept: 'application/json',
                        };
                        if (this.accessToken) {
                            headers = __assign(__assign({}, headers), { authorization: "Bearer " + this.accessToken });
                        }
                        if (data) {
                            headers = __assign(__assign({}, headers), { 'content-type': 'application/json' });
                        }
                        else {
                            headers = __assign(__assign({}, headers), { 'content-type': 'application/json' });
                            data = {};
                        }
                        return [4 /*yield*/, axios_1.default({
                                method: 'PUT',
                                url: "" + this.baseUrl + (path.startsWith('/') ? path : '/' + path),
                                headers: headers,
                                params: params,
                                data: data,
                                validateStatus: function () {
                                    return true;
                                },
                            })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return DataGateway;
}());
exports.DataGateway = DataGateway;
//# sourceMappingURL=dataGateway.js.map